import type { AgentConfig } from "~/shared/types";
import { makeStringComparator } from "~/utils/comparator";

const agentModules = import.meta.glob<{ default: AgentConfig }>("./*/config.ts", { eager: true });

export const TEMPLATE_AGENT_CONFIGS: AgentConfig[] = Object.values(agentModules)
  .map((e) => e.default)
  .sort(makeStringComparator((e) => e.name));

export const AGENT_CONFIG_MAP = new Map(TEMPLATE_AGENT_CONFIGS.map((e) => [e.name, e]));
